import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { DEFAULT_LABELS, roleLabelKey, segmentTierKey } from '../roleLabels';

const RoleLabelsContext = createContext({ labels: DEFAULT_LABELS });

export function RoleLabelsProvider({ children }) {
  const [labels, setLabels] = useState(DEFAULT_LABELS);

  useEffect(() => {
    let alive = true;
    const token = localStorage.getItem('token');
    if (!token) return undefined;
    fetch('/api/role-labels', { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (alive && d && d.labels) setLabels((prev) => ({ ...prev, ...d.labels }));
      })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  return (
    <RoleLabelsContext.Provider value={{ labels }}>
      {children}
    </RoleLabelsContext.Provider>
  );
}

export function useRoleLabels() {
  const { labels } = useContext(RoleLabelsContext);
  const labelByKey = useCallback(
    (key) => labels[key] || DEFAULT_LABELS[key] || key,
    [labels]
  );
  const labelForUser = useCallback((user) => labelByKey(roleLabelKey(user)), [labelByKey]);
  const labelForTier = useCallback(
    (segment, tier) => labelByKey(segmentTierKey(segment, tier)),
    [labelByKey]
  );
  return { labels, labelByKey, labelForUser, labelForTier };
}
